export const datepicker = {
  root: {
    class: ['max-w-full', 'absolute', 'z-overlay'],
  },
  dropdownButton: {
    root: {
      class: [
        'relative',
        'items-center inline-flex text-center align-bottom justify-center',
        'rounded-r-md',
        'py-2 px-0',
        'w-10',
        'leading-[normal]',
        'text-primary-inverse',
        'bg-primary',
        'border border-primary',
        'focus:outline-none focus:outline-offset-0 focus:ring-1',
        'hover:bg-primary-hover hover:border-primary-hover',
        'focus:ring-primary-500',
      ],
    },
  },
  inputicon: {
    class: ['absolute top-[50%] -mt-2', 'text-grey-700', 'right-[.75rem]', 'z-10'],
  },
  panel: ({ props }: Record<string, any>) => ({
    class: [
      // Display & Position
      {
        absolute: !props.inline,
        'inline-block': props.inline,
      },
      // Size
      { 'w-auto p-3 ': !props.inline },
      { 'min-w-[80vw] w-auto p-3 ': props.touchUI },
      { 'p-3 min-w-full z-dialog': props.inline },
      // Shape
      'border rounded-lg',
      {
        'shadow-md': !props.inline,
      },
      // Colors
      'bg-white',
      'border-grey-200',
      // misc
      { 'overflow-x-auto': props.inline },
    ],
  }),
  header: {
    class: [
      'font-medium',
      'flex items-center justify-between',
      'p-0 pb-2',
      'm-0',
      'border-b',
      'rounded-t-md',
      'text-surface-700',
      'bg-white',
      'border-grey-200',
    ],
  },
  pcPrevButton: {
    root: {
      class: [
        'relative',
        'inline-flex items-center justify-center',
        'w-7 h-7',
        'p-0 m-0',
        'rounded-full',
        'text-grey-500',
        'border-0',
        'bg-transparent',
        'transition-colors duration-200 ease-in-out',
        'hover:text-grey-800',
        'hover:bg-grey-100',
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
        'cursor-pointer overflow-hidden',
      ],
    },
    label: {
      class: ['hidden'],
    },
  },
  title: {
    class: ['leading-7', 'mx-auto my-0'],
  },
  selectMonth: {
    class: [
      'text-sm leading-[normal] capitalize',
      'font-medium',
      'rounded-md',
      'text-grey-700',
      'transition duration-200',
      'p-1',
      'm-0 mr-2',
      'hover:text-primary-500',
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      'cursor-pointer',
    ],
  },
  selectYear: {
    class: [
      'text-sm leading-[normal]',
      'font-medium',
      'rounded-md',
      'text-grey-700',
      'transition duration-200',
      'p-1',
      'm-0 mr-2',
      'hover:text-primary-500',
      'focus:outline-none focus:outline-offset-0 fo cus:ring-1 focus:ring-primary-500 focus:z-10',
      'cursor-pointer',
    ],
  },
  pcNextButton: {
    root: {
      class: [
        'relative',
        'inline-flex items-center justify-center',
        'w-7 h-7',
        'p-0 m-0',
        'rounded-full',
        'text-grey-500',
        'border-0',
        'bg-transparent',
        'transition-colors duration-200 ease-in-out',
        'hover:text-grey-800',
        'hover:bg-grey-100',
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
        'cursor-pointer overflow-hidden',
      ],
    },
    label: {
      class: ['hidden'],
    },
  },
  dayView: {
    class: ['text-sm leading-[normal]', 'border-collapse', 'w-full', 'm-0 mt-2'],
  },
  tableHeaderCell: {
    class: ['p-1', 'font-medium'],
  },
  weekHeader: {
    class: ['leading-5', 'text-grey-500', 'opacity-60 cursor-default', 'text-grey-600'],
  },
  weekNumber: {
    class: ['text-grey-500', 'opacity-60 cursor-default'],
  },
  weekday: {
    class: ['text-grey-500', 'capitalize', 'p-1'],
  },
  dayCell: {
    class: ['p-1'],
  },
  weeklabelcontainer: ({ context }: Record<string, any>) => ({
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',
      'mx-auto',
      // Shape & Size
      'w-8 h-8',
      'rounded-full',
      'border-transparent border',
      'leading-[normal]',
      // Colors
      {
        'text-grey-500 bg-transparent': !context.selected && !context.disabled,
        'text-primary-highlight-inverse bg-primary-highlight':
          context.selected && !context.disabled,
      },
      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      {
        'hover:bg-teal': !context.selected && !context.disabled,
        'hover:bg-primary-highlight-hover': context.selected && !context.disabled,
      },
      {
        'opacity-40 cursor-default': context.disabled,
        'cursor-pointer': !context.disabled,
      },
    ],
  }),
  day: ({ context }: Record<string, any>) => ({
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',
      'mx-auto',
      // Shape & Size
      'w-8 h-8',
      'rounded-full',
      'border-transparent border',
      'leading-[normal]',
      // Colors
      {
        'text-grey-900 bg-grey-100': context.date.today && !context.selected && !context.disabled,
        'bg-transparent text-grey-700':
          !context.selected && !context.disabled && !context.date.today,
        'text-white bg-primary-500': context.selected && !context.disabled,
      },
      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      {
        'hover:bg-grey-200': !context.selected && !context.disabled,
      },
      {
        'opacity-40 cursor-default': context.disabled,
        'cursor-pointer': !context.disabled,
      },
    ],
  }),
  monthPicker: {
    class: ['mt-2'],
  },
  month: ({ context }: Record<string, any>) => ({
    class: [
      // Flexbox and Alignment
      'inline-flex items-center justify-center',
      // Size
      'w-1/3',
      'p-1',
      // Shape
      'rounded-md',
      // Colors
      {
        'text-grey-500 bg-transparent': context.disabled,
        'text-primary-highlight-inverse bg-primary-highlight':
          context.selected && !context.disabled,
      },
      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      // Misc
      'cursor-pointer',
    ],
  }),
  yearPicker: {
    class: ['mt-2'],
  },
  year: ({ context }: Record<string, any>) => ({
    class: [
      // Flexbox and Alignment
      'inline-flex items-center justify-center',
      // Size
      'w-1/2',
      'p-1',
      // Shape
      'rounded-md',
      // Colors
      {
        'text-grey-500 bg-transparent': context.disabled,
        'text-primary-highlight-inverse bg-primary-highlight':
          context.selected && !context.disabled,
      },
      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      // Misc
      'cursor-pointer',
    ],
  }),
  timepicker: {
    class: [
      'flex',
      'justify-center items-center',
      'border-t-1',
      'border-solid border-grey-200',
      'pt-2 mt-2',
    ],
  },
  separatorContainer: {
    class: ['flex', 'items-center', 'flex-col', 'px-2'],
  },
  separator: {
    class: ['text-sm'],
  },
  hourPicker: {
    class: ['flex', 'items-center', 'flex-col', 'px-2'],
  },
  minutePicker: {
    class: ['flex', 'items-center', 'flex-col', 'px-2'],
  },
  secondPicker: {
    class: ['flex', 'items-center', 'flex-col', 'px-2'],
  },
  incrementButton: {
    class: [
      'relative',
      'inline-flex items-center justify-center',
      'w-7 h-7',
      'p-0 m-0',
      'rounded-full',
      'text-grey-500',
      'border-0',
      'bg-transparent',
      'transition-colors duration-200 ease-in-out',
      'hover:text-surface-700',
      'hover:bg-surface-100',
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      'cursor-pointer overflow-hidden',
    ],
  },
  decrementButton: {
    class: [
      'relative',
      'inline-flex items-center justify-center',
      'w-7 h-7',
      'p-0 m-0',
      'rounded-full',
      'text-grey-500',
      'border-0',
      'bg-transparent',
      'transition-colors duration-200 ease-in-out',
      'hover:text-surface-700',
      'hover:bg-surface-100',
      'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
      'cursor-pointer overflow-hidden',
    ],
  },
  calendarContainer: {
    class: ['flex'],
  },
  calendar: {
    class: [
      'flex-1',
      'border-l',
      'border-grey-200',
      'pr-0.5',
      'pl-0.5',
      'pt-0',
      'pb-0',
      'first:pl-0',
      'first:border-l-0',
    ],
  },
  buttonbar: ({ attrs }: Record<string, any>) => ({
    class: [
      'flex justify-between items-center',
      'pt-2',
      'border-t border-grey-200',
      { hidden: !attrs['show-today-button'] && !attrs.clearable },
    ],
  }),
  pcTodayButton: ({ attrs }: Record<string, any>) => ({
    root: {
      class: [
        'inline-flex items-center justify-center',
        'px-3 py-1 text-sm leading-[normal]',
        'rounded-md',
        'bg-transparent border-transparent',
        'text-primary',
        'transition-colors duration-200 ease-in-out',
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
        'hover:bg-primary-300/20',
        'cursor-pointer',
        {
          hidden: !attrs['show-today-button'],
        },
      ],
    },
  }),
  pcClearButton: ({ attrs }: Record<string, any>) => ({
    root: {
      class: [
        'inline-flex items-center justify-center',
        'px-3 py-1 text-sm leading-[normal]',
        'rounded-md',
        'bg-transparent border-transparent',
        'text-primary',
        'transition-colors duration-200 ease-in-out',
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 focus:z-10',
        'hover:bg-primary-300/20',
        'cursor-pointer',
        {
          hidden: !attrs.clearable,
          'ml-auto': !attrs['show-today-button'],
        },
      ],
    },
  }),
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
